"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = _interopRequireDefault(require("../styles"));
var _withTheme = _interopRequireDefault(require("@mui/styles/withTheme"));
var _tokens = require("../styles/tokens");
var _EDSContext = require("../EDSContext/EDSContext");
var EventWrapper = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var event = props.event,
    theme = props.theme,
    children = props.children;
  // Check if a 'color' property is attched to the event,
  // if there is, and the color it non-empty then set the color to the value
  // else set to the current theme ctaColor base shade.
  var eventColor = Object.prototype.hasOwnProperty.call(event, 'color') ? event.color.length > 0 && event.color : theme.palette.tertiary.fountain[600];
  var styles = {
    root: {
      '& > .rbc-event': {
        borderLeft: _tokens.borderWidthThickest + " solid " + eventColor
      }
    }
  };

  // events by default don't have tabIndex when using the `components` prop
  // we're expected to manage it ourselves for keyboard accessibility
  // note: if we move to using the 'events' prop instead of 'components', we can remove this
  var decorateChildren = function decorateChildren(child) {
    return /*#__PURE__*/_react.default.cloneElement(child, {
      tabIndex: 0
    });
  };

  /* eslint-disable */
  var div = function div(_ref) {
    var classes = _ref.classes,
      children = _ref.children,
      edsContext = _ref.edsContext;
    return /*#__PURE__*/_react.default.createElement("div", {
      dir: edsContext.dir,
      className: classes.root
    }, decorateChildren(children));
  };
  /* eslint-enable */

  var StyledEventWrapper = (0, _EDSContext.withEDSContext)((0, _styles.default)(styles)(div));
  return /*#__PURE__*/_react.default.createElement(StyledEventWrapper, {
    ref: ref
  }, children);
});
EventWrapper.propTypes = {
  /**
   * Event data sent to the WeekViewSchedule.
   */
  event: _propTypes.default.object.isRequired,
  /**
   * @ignore
   * Material-UI provided theme.
   */
  theme: _propTypes.default.object,
  /**
   * @ignore
   * The children to render from react-big-calendar.
   */
  children: _propTypes.default.any
};
EventWrapper.displayName = 'EventWrapper';
var _default = exports.default = (0, _withTheme.default)(EventWrapper);